import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Slider from "react-slick";
import Typography from '@mui/material/Typography';
import { Card, CardActionArea, CardMedia } from '@mui/material';


const items = [
  {
    key:1,
    title: 'Acceso automatizado',
    description:
      'Controla el ingreso y salida de vehículos de forma eficiente, segura y sin contacto, mediante tecnología de automatización inteligente.',
    image: "https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Flanding_1.jpg?alt=media&token=fb97f291-dbff-4549-8bd0-2b9fd0b6b40b",
  },
  {
    key:2,
    title: '¿Que es?',
    description:
      'Cqurity Access es tu solución integral para el estacionamiento automatizado y el acceso a vehículos, nuestro sistema lo hace todo de forma sencilla, rápida y segura.',
    image: "https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Flanding_2.jpg?alt=media&token=fb3e65db-f6dc-439e-828e-4fbb5e1475bd",
  },
];

const settings = {
  
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  arrows:false
};

export default function Hero() {
  return (
    <React.Fragment>
      <Container maxWidth={'xl'} disableGutters  component='main' sx={{mt:8}}>
      <Slider {...settings} >
        {items.map((item)=>(
           <Box
           sx={{
             height: '512px',
             width: '100vw',
             backgroundImage: `url(${item.image})`,
             backgroundSize: 'cover',
             backgroundPosition: 'center',
             position: 'relative',
             display: 'flex',
             alignItems: 'flex-end',      // Push content to bottom
             justifyContent: 'flex-start', // Align content to the left
             p: 4,
             pb: 6,
             color: '#fff',
           }}
         >
           <Box
             sx={{
               backgroundColor: 'rgba(0, 0, 0, 0.8)',
               p: 3,
               borderRadius: 2,
               maxWidth: {xs:'100%', md:'50%', lg:'20%', xl:'30%'},
             }}
           >
             <Typography variant="h4" >
               {item.title}
             </Typography>
             <Typography variant="h6" sx={{ mt: 1 }}>
             {item.description}
             </Typography>
           </Box>
         </Box>
          ))}
        </Slider>
      </Container>
    </React.Fragment>
  );
}